<lib-full-layout [theme]="theme"></lib-full-layout>